import { render, staticRenderFns } from "./SeminarioUdaySocio.vue?vue&type=template&id=e4eda2de&"
import script from "./SeminarioUdaySocio.vue?vue&type=script&lang=js&"
export * from "./SeminarioUdaySocio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports